import { render, staticRenderFns } from "./VentaParcelasAbonos.vue?vue&type=template&id=5dab2d6e&v-slot%3Acontent=true"
import script from "./VentaParcelasAbonos.vue?vue&type=script&lang=js"
export * from "./VentaParcelasAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports